import { Spinner } from './elements'

const Loading = () => <Spinner className="loading" />

export default Loading



// WEBPACK FOOTER //
// ./src/ui/Overlays/Loading/index.tsx